import { CarouselCaption as _CarouselCaption, CarouselCaptionProps as _CarouselCaptionProps } from "reactstrap";

    export const CarouselCaption = _CarouselCaption;
    export type CarouselCaptionProps = _CarouselCaptionProps;
    